/**
 * SalarieStatut Object
 */
export class SalarieStatut {
    /**
     * @param {object} data
     * @param {number=} data.id
     * @param {string=} data.code
     * @param {string=} data.nom
     */
    constructor({
        id = 0,
        code = null,
        nom = null,
    } = {}) {
        this.id = id
        this.code = code
        this.nom = nom
    }
}

/**
 * SalarieStatut Object used to bind error message
 */
export class ErrorSalarieStatut {
    id
    code
    nom
}